import { FetchJson } from './Fetch';
import { FetchJson as ClientFetchJson } from './client_Fetch'

const coachingAPI = {
    putCoachingDetail:(id?:string, data?:object) => FetchJson.put(`/coaching/${id}/details`, data),
    getCoachingRequest: (data?:object) => FetchJson.get(`/coaching-application/request`, data),
    getCoachingComplete: (data?:object) => FetchJson.get(`/coaching-application/complete`, data),
    getCoachingApp: (id?:string,) => FetchJson.get(`/coaching-application/${id}`),
    getCoachingInProgress:(data?:object) => FetchJson.get(`/admin-coaching`, data),

    requestCoachingItem:(id:string, itemId:string, data?:object) => ClientFetchJson.put(`/coaching/${id}/coaching-type/${itemId}/application`, data),

// /coaching-application/{applicationId}/reply
    postCoachingRequest:(id:string,data?:object) => FetchJson.put(`/coaching-application/${id}/reply`, data),
    postRequestVideo:(id ,data?:object) => FetchJson.put(`/coaching-application/${id}/reply-video`,data),
    postRequestClassic:(id ,data?:object) => FetchJson.put(`/coaching-application/${id}/reply-classic`,data),
    putCoachingProducts: (id?:string, data?:object) => FetchJson.put(`/coaching/${id}/products`, data),   
    putCoachingPauseStåte:(id?:string, data?:object) => FetchJson.put(`/admin-coaching/${id}`, data),
    //
    putCoachingAbout:(id?:string, data?:object) => FetchJson.put(`/coaching/${id}/about`, data),
    putCoachingShowcase:(id?:string, data?:object) => FetchJson.put(`/coaching/${id}/showcase`, data),   
    postCoachingTestimonials:(id?:string, data?:object) => FetchJson.post(`/coaching/${id}/testimonials`, data),   
    deleteCoachingTestimonials:(id?:string, testimonialsId?:string) => FetchJson.delete(`/coaching/${id}/testimonials/${testimonialsId}`),   
    
    putCoachingTestimonials:(id?:string, data?:object) => FetchJson.put(`/coaching/${id}/testimonials`, data),   
    patchCoachingTestimonial:(id?:string, selectId?:string, data?:object) => FetchJson.patch(`/coaching/${id}/testimonials/${selectId}`, data),
    createCoaching:(data?:object) => FetchJson.post(`/coaching`,data),
    getProductById: (id, data?:object) => FetchJson.get(`/coaching/${id}`,data),
    getCoachingList: (data?:object) => FetchJson.get(`/coaching/products`,data),
    postSubmitCoaching: (id ,data?:object) => FetchJson.post(`/coaching/${id}/submit`,data),
    postAdminSubmitCoaching: (id ,data?:object) => FetchJson.post(`/admin-coaching/${id}/in-progress`,data),
    putAdminSubmitCoaching: (id ,data?:object) => FetchJson.put(`/admin-coaching/${id}/progress`,data),
    getAdminSubmitCoaching: (id ,data?:object) => FetchJson.get(`/admin-coaching/${id}/in-progress`,data),
    createCoachingApp:(id, data?:object) => FetchJson.put(`/coaching/${id}`,data),
    deleteCoachingItem:(id) => FetchJson.delete(`/coaching/${id}`),
    updateTimeAway:(id, data) => FetchJson.put(`/coaching/${id}/time-away`, data),
    getProductStep: (id, data?:object) => FetchJson.get(`/coaching/${id}/step`,data),
    putSubmitCoaching: (id ,data?:object) => FetchJson.put(`/admin-coaching/${id}/progress`,data),
}

export { coachingAPI };